<template>
    <div>
        <div id="signature-pad" class="m-signature-pad">
            <div class="m-signature-pad--body">
                <canvas ref="canvas" id="canvas" style="background: #eee; width: 100%;height: 300px;"></canvas>
            </div>
            <div class="flex justify-between mt-4">
                <button @click="save" type="submit" :class="`py-1 px-2 bg-${$root.theme}-300 border border-${$root.theme}-500 rounded text-${$root.theme}-700`">Save</button>
                <button @click.prevent="signaturePad.clear()" class="py-1 px-2 border border-gray-500 rounded" data-action="clear" type="button">Clear</button>
            </div>
        </div>
        <input ref="input" :value="signatureImage" type="hidden" name="signature" id="input-signature">
    </div>
</template>

<script>
    import Mixins from '../mixins';
    import SignaturePad from 'signature_pad';

    export default {
        mixins: [Mixins],

        data() {
            return {
                signaturePad: null,
                signatureImage: null,
                signedAt: null
            }
        },

        mounted() {
            window.onresize = () => this.resizeCanvas(this.$refs.canvas);

            this.resizeCanvas(this.$refs.canvas);

            this.signaturePad = new SignaturePad(this.$refs.canvas);
        },

        methods: {
            /**
             * @param canvas
             * @returns {void}
             */
            resizeCanvas(canvas) {
                let ratio =  Math.max(window.devicePixelRatio || 1, 1);

                canvas.width = canvas.offsetWidth * ratio;
                canvas.height = canvas.offsetHeight * ratio;

                canvas.getContext("2d").scale(ratio, ratio);
            },

            save() {
                this.signatureImage = this.signaturePad.toDataURL();
            }
        }
    }
</script>